/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'
import config from '../../config'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import { Row, Col, Card } from 'react-bootstrap'
import { format, parse } from 'date-fns'
import { get, orderBy } from 'lodash'

import callApi from '../../helpers/callapi'
import OrderStatus from './OrderStatus'
import OrderListItem from './OrderListItem'
import OrderDetail from './OrderDetail'
import PerfectScrollbar from 'react-perfect-scrollbar'
import OrderSelectedCard from './OrderSelectedCard'
import Paginations from '../../components/Nav/Pagination'
import * as uuid from 'uuid'
import { getRounds } from '../../services/config-services'

const OrderExtras = () => {
  const [orders, setOrders] = useState([])

  const [selectedOrder, setSelectedOrder] = useState({})
  const [status, setStatus] = useState('receipt attached')
  const [fullPage, setFullPage] = useState(false)
  const [bgCardColor, setBgCardColor] = useState('bg-info')
  const [messageStatus, setMessageStatus] = useState('แนบสลิปแล้ว')
  const [currentPage, setCurrentPage] = useState(1)
  const [queryState, setQueryState] = useState('status')
  const [value, setValue] = useState('receipt attached')
  const [showCard, setShowCard] = useState(false)
  const [isEnter, setIsEnter] = useState(false)
  const [page, setPage] = useState('')
  const [enterValue, setEnterValue] = useState('')

  const [rounds, setRounds] = useState([])
  const [roundDate, setRoundDate] = useState()
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [typeFreeShirt, setTypeFreeShirt] = useState('')
  const [currentPageShirt, setCurrentPageShirt] = useState(1)
  const [ordersExtarsFree, setOrdersExtarsFree] = useState([])

  const dispatch = useDispatch()

  const Header = {
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    params: {
      //   รอ backend แก้ pagination
      // ...(page === 'next' && {
      //   next: orders[orders.length - 1].orderId,
      // }),
      // ...(page === 'prev' && {
      //   prev: orders[0].orderId,
      // }),
      query: queryState,
      value: queryState === 'status' ? value : enterValue,
    },
  }

  const fetCheckPayment = async () => {
    const result = await axios.get(`${config.baseAPIExists}/admin/extras/orders`, Header)
    return result.data
  }

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRoundDate(data[0].value)
    setRounds(data.map((r) => ({ roundDate: r.value })))
  }

  /// Start Random ///
  const fetchShirtFree = async () => {
    dispatch({ type: 'loading_show' })
    const result = await callApi({
      url: `/freeItems/${roundDate}?${currentPageShirt > 1 ? `page=${currentPageShirt}&` : ''}${typeFreeShirt === 'confirmed' ? 'available=confirmed&' : typeFreeShirt === 'pending' ? 'available=pending&' : ''}`,
    })
    if (result.data.length <= 0) {
      setOrdersExtarsFree([])
      dispatch({ type: 'loading_hide' })
      return
    } else {
      setOrdersExtarsFree(result.data)
    }
    dispatch({ type: 'loading_hide' })
  }

  useEffect(() => {
    if (status === 'random') {
      fetchShirtFree()
    } else {
      return
    }
  }, [roundDate, typeFreeShirt, currentPageShirt])

  // Fillter Random
  const onChangePageShirt = (page) => {
    setCurrentPageShirt(page)
  }

  /// End random shirt  ///

  const onChangePage = (page) => {
    setCurrentPage(page)
    setFullPage(false)
    setShowCard(false)
  }

  useEffect(() => {
    fetchAllRounds()
  }, [])

  useEffect(async () => {
    dispatch({ type: 'loading_show' })
    const result = await Promise.all([fetCheckPayment()])
    if (!result[0].data === []) {
      setOrders(result[0].data)
    }
    if (status === 'random' && ordersExtarsFree.length === 0) {
      fetchShirtFree()
    }
    dispatch({ type: 'loading_hide' })
  }, [status, !showCard, isEnter, currentPage])

  const handleOnClickOrderStatus = (value) => {
    setMessageStatus(value.message)
    setBgCardColor(value.color)
    setStatus(value.status)
    setQueryState('status')
    setValue(value.status)
    setFullPage(false)
    setSelectedOrder({})
    setPage('')
  }

  const handleOnEnter = () => {
    setMessageStatus(`ผลการค้นหา`)
    setIsEnter(true)
    setStatus('search')
    setBgCardColor('bg-primary')
    setFullPage(false)
    setShowCard(false)
    setEnterValue(value)
  }

  const handleCancel = () => {
    setFullPage(false)
    setSelectedOrder({})
  }

  const handleApprove = () => {
    setFullPage(false)
    setShowCard(false)
  }

  const orderFiltered = orders.filter((order) => order.status === status)
  const unSelectedCard = orderFiltered.filter((s) => s.ref !== selectedOrder.ref)

  const unSelectedSearchCard = orders.filter((search) => search.ref !== selectedOrder.ref)

  return (
    <Fragment>
      <h3 style={{ textAlign: 'center' }}>เสื้อกองสลากพลัส</h3>
      <OrderStatus workingStatus={status} onClick={(value) => handleOnClickOrderStatus(value)} />

      {/* Search Input */}
      {status !== 'random' && (
        <div className="d-flex mt-2 mb-4">
          <input
            className="form-control mx-2"
            style={{ color: '#5d5d5d' }}
            type="text"
            placeholder="หมายเลขคำสั่งซื้อ"
            onChange={(e) => {
              setQueryState('ref')
              setValue(e.target.value)
              setIsEnter(false)
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                // onChangePage(1, {});
                handleOnEnter()
              }
            }}
          />
          <input
            className="form-control "
            style={{ color: '#5d5d5d' }}
            type="text"
            placeholder="รหัสสมาชิก"
            onChange={(e) => {
              setValue(e.target.value)
              setQueryState('userId')
              setIsEnter(false)
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                // onChangePage(1, {});
                handleOnEnter()
              }
            }}
          />
        </div>
      )}

      {status === 'random' ? (
        <>
          <Row className="mt-4">
            <Col md={3}>
              <label> รอบวันที่ : </label>
              <select
                className="form-control"
                value={roundDate}
                onChange={async (e) => setRoundDate(e.target.value) & setTypeFreeShirt('')}
              >
                {rounds &&
                  rounds.map((round, i) => {
                    return (
                      <option key={i} value={round.roundDate}>
                        {round.roundDate}
                      </option>
                    )
                  })}
              </select>
            </Col>
            <Col>
              <label> สถานะ : </label>
              <br />
              <div className="btn-group mb-2 mx-2">
                <button
                  className={`btn btn-outline-dark`}
                  onClick={() => (setTypeFreeShirt(''), setCurrentPageShirt(1))}
                >
                  {' '}
                  ทั้งหมด{' '}
                </button>
                <button
                  className={`btn btn-outline-new-orange`}
                  onClick={() => (setTypeFreeShirt('pending'), setCurrentPageShirt(1))}
                >
                  รอดำเนินการ
                </button>
                <button
                  className={`btn btn-outline-success`}
                  onClick={() => (setTypeFreeShirt('confirmed'), setCurrentPageShirt(1))}
                >
                  ยืนยันแล้ว
                </button>
              </div>
            </Col>
          </Row>
          {/* random shirt */}
          <Row>
            <Col>
              <div
                className="border"
                style={{
                  maxHeight: '45vh',
                  minHeight: '10vh',
                  height: '100%',
                  width: '100%',
                  overflowY: 'auto',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                }}
              >
                <table className="table table-sm table-responsive-md text-center ">
                  <thead className="table-dark sticky-top">
                    <tr>
                      <th>ลำดับ</th>
                      <th scope="col">รหัสสมาชิก</th>
                      <th scope="col">ชื่อลูกค้า</th>
                      <th scope="col">หมายเลขคำสั่งซื้อ</th>
                      <th scope="col">เบอร์โทร</th>
                      <th scope="col">สถานะ</th>
                    </tr>
                  </thead>
                  <tbody className="table-hover">
                    {ordersExtarsFree.map((items, j) => {
                      const conditionColor = items.status == false
                      return (
                        <Fragment key={j}>
                          <tr>
                            <td>{j + 1}</td>
                            <td>{items.userId}</td>
                            <td>{items.userName}</td>
                            <td>#{items.refNo}</td>
                            <td>{items.phone}</td>
                            <td>
                              <span
                                className={`badge rounded-pill  text-white ${conditionColor ? `bg-new-orange ` : `bg-success text-white`} `}
                              >
                                {conditionColor ? 'รอดำเนินการ' : 'ยืนยันแล้ว'}
                              </span>
                            </td>
                          </tr>
                        </Fragment>
                      )
                    })}
                  </tbody>
                </table>
                {ordersExtarsFree.length <= 0 && (
                  <div className="text-center mb-3 mt-1">
                    <h4 className="text-muted">ไม่พบข้อมูล</h4>
                  </div>
                )}
              </div>
              {!ordersExtarsFree.length <= 0 && (
                <div>
                  <Paginations
                    currentPage={currentPageShirt}
                    onPrevPage={() => onChangePageShirt(currentPageShirt - 1)}
                    onNextPage={() => onChangePageShirt(currentPageShirt + 1)}
                    items={ordersExtarsFree}
                  />
                </div>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <Row className="mt-0 pt-0">
          <Col sm={fullPage ? 12 : 4} lg={fullPage ? 12 : 4} md={fullPage ? 12 : 4} xl={fullPage ? 12 : 4}>
            <Card className={bgCardColor} style={{ height: 'auto' }}>
              <Row>
                <Col>
                  <div>
                    <Card.Header>
                      <Card.Title style={{ width: '100%' }}>
                        <div className="d-flex text-white align-items-center justify-content-between">
                          <div>{messageStatus} </div>
                        </div>
                      </Card.Title>
                      {fullPage && (
                        <span
                          onClick={() => {
                            handleCancel()
                          }}
                          className="badge"
                          style={{
                            borderRadius: '5rem',
                            backgroundColor: '#000',
                            color: 'white',
                            cursor: 'pointer',
                          }}
                        >
                          X
                        </span>
                      )}
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col md={fullPage ? 4 : 12} lg={fullPage ? 4 : 12}>
                          {showCard && selectedOrder.ref && (
                            <Row>
                              <Card style={{ width: '100%', background: '#fff' }}>
                                <OrderSelectedCard order={selectedOrder} workingStatus={status} />
                              </Card>
                            </Row>
                          )}
                          <div style={{ paddingRight: '16px' }}>
                            <PerfectScrollbar
                              style={{ maxHeight: '850px' }}
                              id="DZ_W_Todo2"
                              className="widget-media dz-scroll ps ps--active-y"
                            >
                              {queryState === 'status' ? (
                                <ul className="timeline">
                                  {unSelectedCard &&
                                    unSelectedCard.map((order, i) => (
                                      <li
                                        key={i}
                                        onClick={() => {
                                          setSelectedOrder(order)
                                          setShowCard(true)
                                          setFullPage(true)
                                        }}
                                      >
                                        <OrderListItem order={order} workingStatus={status} />
                                      </li>
                                    ))}
                                </ul>
                              ) : (
                                <ul className="timeline">
                                  {unSelectedSearchCard &&
                                    unSelectedSearchCard.map((order, i) => (
                                      <li
                                        key={i}
                                        onClick={() => {
                                          setSelectedOrder(order)
                                          setShowCard(true)
                                          setFullPage(true)
                                        }}
                                      >
                                        <OrderListItem order={order} workingStatus={status} />
                                      </li>
                                    ))}
                                </ul>
                              )}
                            </PerfectScrollbar>
                          </div>
                        </Col>
                        {fullPage && (
                          <Col md={8} lg={8}>
                            <OrderDetail key={uuid.v4()} order={selectedOrder} onCancel={() => handleApprove()} />
                          </Col>
                        )}
                      </Row>
                    </Card.Body>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      )}

      {/* รอ pagination */}
      {/* <Paginations
        currentPage={currentPage}
        onPrevPage={() =>{
          setPage('prev')
          onChangePage(currentPage - 1, {
            prev: orders[0].orderId,
          })
        }
        }
        onNextPage={() => {
          setPage('next')
          onChangePage(currentPage + 1, {
            next: orders[orders.length - 1].orderId,
          })
        }
        }
        items={orders}
        perPage={20}
      /> */}
    </Fragment>
  )
}

export default OrderExtras
